import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const SuperUserRoleVersionData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();
  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.role_id ?? "--"}</td>
      <td className="table-each-row-data">{data?.role_name ?? "--"}</td>
      <td className="table-each-row-data">
        {data?.vendorRoleVersion?.updatedBy?.name ?? "--"}
      </td>
      <td className="table-each-row-data">
        {data?.vendorRoleVersion?.updatedAt
          ? moment(data?.data?.vendorRoleVersion?.updatedAt).format(
              "DD MMM YYYY, HH:MM A"
            )
          : "--"}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/super-user/role/version-history-detail/${data.id}`)
            }
          >
            view
          </button>
        </div>
      </td>
    </tr>
  );
};

export default SuperUserRoleVersionData;
